export class RiderPlaceFeedbackApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Send a suggestion or a correction (201; 200 for a retry of the same key). 429 `PLACE_FEEDBACK_RATE_LIMITED`, 409 `PLACE_FEEDBACK_PENDING_LIMIT`. */
    submit(input) {
        return this.client.request({ method: 'POST', path: '/v1/rider/place-feedback', body: input, auth: true });
    }
}
const q = (query) => {
    const parts = Object.entries(query).flatMap(([k, v]) => (v === undefined || v === '' ? [] : [`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`]));
    return parts.length === 0 ? '' : `?${parts.join('&')}`;
};
const path = (id, action) => `/v1/admin/places/feedback/${encodeURIComponent(id)}/${action}`;
export class AdminPlaceFeedbackApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The queue for the scope (`places:view` there). */
    list(query = {}) {
        return this.client.request({ method: 'GET', path: `/v1/admin/places/feedback${q({ ...query })}`, auth: true });
    }
    /**
     * Accept (`places:manage`): creates the place (source `rider_suggestion`) or corrects / hides the base place. 409 `PLACE_FEEDBACK_VERIFIED_PROTECTED` without the
     * override, `PLACE_FEEDBACK_IN_REVIEW` while another decision holds it, `PLACE_FEEDBACK_NOT_APPLICABLE` for a comment.
     */
    accept(id, body = {}) {
        return this.client.request({ method: 'POST', path: path(id, 'accept'), body, auth: true });
    }
    /** Merge into a place the base already has; the rider's name becomes an alias (not on a verified place without the override). */
    merge(id, placeId, overrideVerified = false) {
        return this.client.request({ method: 'POST', path: path(id, 'merge'), body: { placeId, ...(overrideVerified ? { overrideVerified } : {}) }, auth: true });
    }
    /** Turn the suggestion down with one of the reasons. */
    reject(id, reason) {
        return this.client.request({ method: 'POST', path: path(id, 'reject'), body: { reason }, auth: true });
    }
    /** Mark a comment about the search as handled (only a comment; 409 `PLACE_FEEDBACK_NOT_APPLICABLE` otherwise). */
    handle(id) {
        return this.client.request({ method: 'POST', path: path(id, 'handle'), body: {}, auth: true });
    }
}
//# sourceMappingURL=place-feedback.js.map